<template>
<div>
<v-footer
        row
        class="text-center super-footer"
        color="#407FC2"
      >
        <v-flex xs12 hidden-lg-and-up>
          <h4 class="margin-bottom">Connect on Social</h4>
          <v-layout justify-center>
            <v-flex xs2>
                <a class="hover center" href="https://www.facebook.com/McVitiesOfficial/" target="_blank" id="sm-fb">
                <v-img
                  :src="fbImage"
                  contain
                  height="28"
                >
                </v-img>
                </a>
            </v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs2>
              <a class="hover center" href="https://twitter.com/McVities" target="_blank" id="sm-tw">
              <v-img
                  :src="twImage.src"
                  contain
                  height="28"
                >
                </v-img>
                </a>
            </v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs2>
                <a class="hover center" href="https://www.youtube.com/user/McVitiesBiscuitsUK" target="_blank" id="sm-yt">
                <v-img
                  :src="ytImage.src"
                  contain
                  height="28"
                >
                </v-img>
                </a>
            </v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs2>
                <a class="hover center" href="https://www.instagram.com/mcvitiesofficial" target="_blank" id="sm-yt">
                <v-img
                  :src="inImage.src"
                  contain
                  height="28"
                >
                </v-img>
                </a>
            </v-flex>
          </v-layout>
          <p></p>
        </v-flex>
        <v-flex xs12 hidden-md-and-down>
          <v-layout row wrap justify-center justify="center">
                <v-flex md8>
                  <h4 class="inline">Connect on Social</h4>
                  <v-btn class="footer-btn" href="https://www.facebook.com/McVitiesOfficial/" target="_blank" text icon>
                    <v-img
                      :src="fbImage.src"
                      contain
                      height="28"
                    >
                    </v-img>
                  </v-btn>
                  <v-btn class="footer-btn" href="https://twitter.com/McVities" target="_blank" text icon>
                     <v-img
                      :src="twImage.src"
                      contain
                      height="28"
                    >
                    </v-img>
                  </v-btn>
                  <v-btn class="footer-btn" href="https://www.youtube.com/user/McVitiesBiscuitsUK" target="_blank" text icon>
                    <v-img
                      :src="ytImage.src"
                      contain
                      height="28"
                    >
                    </v-img>
                  </v-btn>
                  <v-btn class="footer-btn" href="https://www.instagram.com/mcvitiesofficial" target="_blank" text icon>
                    <v-img
                      :src="inImage.src"
                      contain
                      height="28"
                    >
                    </v-img>
                  </v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
      </v-footer>
    <v-footer 
      color="#2b3674"
      height="auto"
      class="sub-footer"
    >
      <v-layout row class="text-center" justify-center justify="center">
        <v-flex xs12 hidden-lg-and-up>
          <h4>
            <a class="hover" href="http://www.unitedbiscuits.com/media-centre/contact-us/" target="_blank">Customer Care</a>
            <br />
            <a class="hover" href="http://123healthybalance.com/" target="_blank">123 Healthy Balance</a>
            <br />
            <a class="hover" href="http://www.mcvities.com/" target="_blank">McVitie's International</a>
          </h4>
          <p>
            <a class="hover" href="http://pladisglobal.com/" target="_blank">Pladis</a> | <a href="/terms" target="_blank">T&amp;Cs</a> | <a href="/privacy" target="_blank">Privacy Notice</a> | <a href="http://www.mcvities.co.uk/conditions-of-use" target="_blank">Conditions Of Use</a>
          </p>
        </v-flex>
        <v-flex xs12 md8 hidden-md-and-down text-md-left justify-center justify="center">
            <h4 class="text-center">
                <a class="hover" href="http://www.unitedbiscuits.com/media-centre/contact-us/" target="_blank">Customer Care</a>
                <span class="space-around">.</span>
                <a class="hover" href="http://123healthybalance.com/" target="_blank">123 Healthy Balance</a>
                <span class="space-around">.</span>
                <a class="hover" href="http://mcvities.com/" target="_blank">McVitie's International</a>
            </h4>
            <p class="text-center">
                <a class="hover" href="http://pladisglobal.com/" target="_blank">Pladis</a> | 
                <a class="hover" href="/terms" target="_blank">T&amp;Cs</a> | 
                <a class="hover" href="/privacy" target="_blank">Privacy Notice</a> | 
                <a class="hover" href="http://mcvities.co.uk/conditions-of-use" target="_blank">Conditions Of Use</a>
            </p>
        </v-flex>
      </v-layout>
    </v-footer>
    </div>
</template>

<script>
export default {
  name: 'Footer',
  mounted() {
    this.axios.get('/data/shortTerms.json').then((response)=>{
      this.shortTerms = response.data.payload[0].contents
    })
  },
  data: () => ({
    shortTerms: [],
    fbImage: {src:require('../assets/icons/Facebook Icon.png')},
    ytImage: {src:require('../assets/icons/Youtube Icon.png')},
    twImage: {src:require('../assets/icons/Twitter Icon.png')},
    inImage: {src:require('../assets/icons/Instagram logo.png')} 
  }),
};
</script>
